import axios from 'axios'
import { useMutation } from 'react-query'

import { useUrl } from '.'
import { Apis } from '../appSettings/AppSettings'

export const useRefreshSession = () => {
  const url = useUrl(Apis.account)

  return useMutation({
    mutationFn: () => axios.get<{ expires: string }>(`${url}/RefreshSession`)
  })
}

export const useGetExpires = () => {
  const url = useUrl(Apis.account)

  return useMutation({
    mutationFn: () => axios.get<{ expires: string }>(`${url}/GetExpires`)
  })
}